import React from "react";
import { NavLink as RouterLink, useLocation } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Button, ListItem, makeStyles } from "@material-ui/core";
import { ReactSVG } from "react-svg";
import { callHelpDesk } from "../../helpers/api/api";
import { callGetEventToken } from "../../reducers/events";
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
  item: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
    color: theme?.palette?.leftBar?.text,
    "& a": {
      "& span": {
        display: "flex !important",
        alignItems: "center !important",
        justifyContent: "center !important",
        gap: "8px !important",
      },
    },
  },
  button: {
    //color: "#060236",
    fontWeight: "400",
    justifyContent: "flex-start",
    letterSpacing: 0,
    padding: "12px 5px 12px 30px",
    textTransform: "none",
    width: "100%",
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  title: {
    marginRight: "auto",
  },
  iconWhite: {
    display: "none",
    marginRight: " 8px",
  },
  active: {
    fontWeight: "400",
    color: theme.UpdateTheme.text_color,
    borderRadius: "0px ",
    background: theme.UpdateTheme.button_color,
    "& $title": {
      fontWeight: "400",
    },
    "& $icon": {
      color: theme.palette.primary.text,
    },
    "&:focus": {
      backgroundColor: theme.UpdateTheme.button_color,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.UpdateTheme.text_color,
      },
    },
    "&:hover": {
      backgroundColor: theme.UpdateTheme.button_color,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.UpdateTheme.text_color,
      },
    },
  },
  iconswrapper: {
    "& div": {
      display: "flex",
      width: "20px",
      height: "20px",
    },
  },
  "& .MuiButton-label": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  iconed: {
    "& svg": {
      fill: "black",
      width: ({ size }) => size,
      height: ({ size }) => size,
      transform: ({ transform }) => transform,
      "& path": {
        fill: ({ color }) => color && theme.UpdateTheme.text_color,
      },
    },
  },
}));

const NavItem = ({
  className,
  href,
  icon,
  title,
  callGetEventToken,
  ...rest
}) => {
  const location = useLocation();
  const isActive = location.pathname.includes(href);
  const props = {
    color: isActive,
    size: "20px",
    transform: "none",
  };
  const classes = useStyles(props);
  const handleHelpDeskClick = async () => {
    const res = await callHelpDesk();
    window.open(res.result);
  };

  const handleInstant = () => {
    const body = {
      key: "abc",
    };
    callGetEventToken(body).then((res) => {
      window.open(res?.results, "_blank");
      localStorage.setItem("url", res?.results);
    });
  };

  return (
    <ListItem
      className={clsx(classes.item, className)}
      disableGutters
      {...rest}
    >
      <Button
        activeClassName={`${
          title === "Help Desk" || title === "Video Conferencing"
            ? ""
            : classes.active
        } active_dark`}
        className={classes.button}
        component={RouterLink}
        to={href}
        onClick={() => {
          if (title === "Help Desk") handleHelpDeskClick();
          if (title === "Video Conferencing") {
            handleInstant();
          }
        }}
      >
        {icon && (          
            <ReactSVG
              src={require("../../images/" + icon + ".svg")}
              className={`${classes.iconswrapper} ${classes.iconed}`}
            />
        )}
        <span className={classes.title} target="_blank">
          {title}
        </span>
      </Button>
    </ListItem>
  );
};

NavItem.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  title: PropTypes.string,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  callGetEventToken: (inputs) => dispatch(callGetEventToken(inputs)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavItem);
